module.exports = __webpack_public_path__ + "media/megamenu/ReturnArt-8e35ac2a.svg";